import store from '../store';
import * as productActions from './product';

/**
 * Add product to local shopper store key
 */
export function addProduct(product, skuId, qty = 1) {
  const cartItems = store.get('shopper.cart.items');
  const itemIndex = cartItems.findIndex(item => item.productId == product.id);
  const hasProduct = itemIndex !== -1;

  if (hasProduct) {
    // Increment 'qty' for existing product
    cartItems[itemIndex].qty += qty;
  } else {
    // Add new item to array
    cartItems.push(convertProductToCartItem(product, skuId, qty));
  }

  store.set('shopper.cart.items', cartItems);
}

/**
 * Convert product to stored cart item
 */
export function convertProductToCartItem(product, skuId, qty = 1) {
  return {
    productId: product.id,
    name: product.name,
    skuId,
    price: product.price || { amount: 0, currency: 'USD' }, // object { amount, currency }
    qty,
  };
}

/**
 * Get cart products in local cache
 */
export function getLocalCartProducts() {
  const cartItems = store.get('shopper.cart.items');
  const productIds = cartItems.map(item => item.productId);

  return productActions.getLocalProductsByIds(productIds);
}

/**
 * Remove local cart item
 */
export function removeLocalCartItem(cartItem) {
  const cartItems = store.get('shopper.cart.items');
  const cartProducts = cartItems.filter(item => item.productId !== cartItem.productId);

  store.set('shopper.cart.items', cartProducts);

  return cartProducts;
}

/**
 * Update local cart item qty
 */
export function updateLocalCartItemQty(cartItem, qty = 1) {
  const cartItems = store.get('shopper.cart.items');
  const itemIndex = cartItems.findIndex(item => item.productId == cartItem.productId);
  const hasProduct = itemIndex !== -1;

  if (hasProduct) {
    // Increment 'qty' for existing product
    cartItems[itemIndex].qty = qty;

    store.set('shopper.cart.items', cartItems);
  }
}

/**
 * Remote/async actions (all of which return a Promise)
 */
export const remote = {
  /**
   * Re-hydrate products in shopper's cart
   */
  fetchCartProducts() {
    const cartItems = store.get('shopper.cart.items');
    const productIds = cartItems.map(item => item.productId);

    return productActions.remote.fetchByIds(productIds);
  },
};
